import helpers, {lastPageYOffset} from '../helpers';

let winWidth = helpers.$window.innerWidth();
const $burgerBtn = $('.js-burger-btn');
const $burgerMenu = $('.js-burger-menu');
const $linkMenu = $('.menu__link');

function openMenu() {
	helpers.saveScrollPosition();
	helpers.$html.css({
		top: `-${lastPageYOffset}px`,
	}).addClass('is-lock-scroll');

	helpers.$body.css({
		paddingRight: `${helpers.getScrollbarWidth()}px`,
	});
	helpers.$header.css({
		transition: '0s',
		right: `${helpers.getScrollbarWidth()}px`,
	});
	$burgerBtn.addClass('is-active');
	$burgerMenu.addClass('is-active');
	helpers.$header.addClass('is-active');
}

function closeMenu() {
	if ($burgerBtn.hasClass('is-active')) {
		helpers.$html.css({
			top: '',
		}).removeClass('is-lock-scroll');
		helpers.$body.css({
			paddingRight: '',
		});
		helpers.$header.css({
			right: '',
		});
		helpers.restoreScrollPosition();
		$burgerBtn.removeClass('is-active');
		$burgerMenu.removeClass('is-active');
		helpers.$header.removeClass('is-active');

		setTimeout(() => {
			helpers.$header.css({
				transition: '',
			});
		}, 400);
	}
}

function menuToggle(e) {
	if ($(e.currentTarget).hasClass('is-active')) {
		closeMenu();
	} else {
		openMenu();
	}
}

function menuLink(e) {
	e.preventDefault();
	const id = $(e.currentTarget).attr('href');

	helpers.scrollTo($(id));

	if ($burgerBtn.hasClass('is-active')) {
		closeMenu();
	}
}

function init() {
	$burgerBtn.on('click.burger', menuToggle);
	$linkMenu.on('click', menuLink);

	$linkMenu.each((i, e) => {
		let location = window.location.pathname;
		let link = $(e).attr('href');

		if (location === link) {
			$(e).addClass('is-active');
		}
	});
}

function destroy() {
	closeMenu();
	$burgerBtn.off('.burger');
}

function resize() {
	helpers.debounce(() => {
		if (winWidth !== helpers.$window.innerWidth()) {
			closeMenu();

			winWidth = helpers.$window.innerWidth();
		}
	}, 300);
}

helpers.$window.on('resize', resize);

export default {
	init,
	destroy,
	closeMenu,
};
